import React, { lazy, Suspense } from 'react';
const PieComponent = lazy(() => import('./index'));

const WrapperPieComponent = ({ data, options, shouldLoad = true }) => {
    return shouldLoad && (
        <Suspense fallback={<div>Cargando gráfico...</div>}>
            <PieComponent data={data} options={options} />
        </Suspense>
    );
};

export default WrapperPieComponent;
